import React, { useEffect, useState } from "react";

const reCaptchaScorePlusDomId: string = "reCaptchaV3-siteKey";

declare global {
  interface Window {
    grecaptcha: any;
  }
}

const REcaptcha = ({ siteKey, action, onTokenChange }: { siteKey: string; action:string; onTokenChange: (token: string | null) => void }) => {

  useEffect(() => {
    if (window.grecaptcha) {
      window.grecaptcha.enterprise.render("recaptchaElement", {
        siteKey,
        action: action,
        callback: handleRecaptchaChange,
      });
    } else {
      console.error("grecaptcha is not defined, script may not be loading correctly.");
    }
  }, [siteKey]);

  const handleRecaptchaChange = (token: string | null) => {
    console.log("Captcha Token Generated");
    onTokenChange(token);
  };

  return <div id="recaptchaElement" className="g-recaptcha" data-sitekey={siteKey} data-action="login"></div>;
};

export default REcaptcha;
